import React from 'react';
import { Hero } from '../components/home/Hero';
import { WhatIsSCB300 } from '../components/home/WhatIsSCB300';
import { CoreValues } from '../components/home/CoreValues';
import { ProductShowcase } from '../components/home/ProductShowcase';
import { WhyDTech } from '../components/home/WhyDTech';
import { Applications } from '../components/home/Applications';
import { DemoRequest } from '../components/home/DemoRequest';
import { ContactSection } from '../components/home/ContactSection';
import { PromoPopup } from '../components/home/PromoPopup';
interface HomePageProps {
  onRequestQuote: (productId?: string) => void;
}
export function HomePage({
  onRequestQuote
}: HomePageProps) {
  return <main data-id="element-650">
      <PromoPopup onRequestQuote={() => onRequestQuote()} data-id="element-651" />
      <Hero onRequestQuote={() => onRequestQuote()} data-id="element-652" />
      <WhatIsSCB300 data-id="element-653" />
      <CoreValues data-id="element-654" />
      <ProductShowcase onRequestQuote={onRequestQuote} data-id="element-655" />
      <WhyDTech data-id="element-656" />
      <Applications data-id="element-657" />
      <DemoRequest onRequestQuote={() => onRequestQuote()} data-id="element-658" />
      <ContactSection data-id="element-659" />
    </main>;
}